import { TaskDescriptionEditor } from 'components/molecules/tasks/details/description/editor';
import { withAccess } from 'hooks/rbac/withAccess';

export const RbacTaskDescriptionEditor = withAccess(TaskDescriptionEditor);
